import React from "react";

import { Button } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";

const BaselineCostsCard = (props) => {
  const {
    modelGroups,
    setup,
    updateBaselineConversionGain,
    updateBaselineConversionCost,
    updateBaselineConversionMissed,
    updateBaselineConversionSaved,
    updateBaselineCustomValue,
    removeBaselineCustomValuesMultipleSegments,
    updateShowBaselines,
    project,
    runId
  } = props;

  const modelGroupSegments =
    modelGroups === undefined
      ? { model: {}, setup: setup, runId: runId }
      : modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length > 1
        ? modelGroups.drilldownValues.filter((model) => model.column !== "Overall")
        : modelGroups.drilldownValues[0];

  const isCustomValues = setup && setup.customValues && Object.keys(setup.customValues).length > 0;

  const isBaseline = (project && project.settings && project.settings.showBaselines) || modelGroups === undefined;

  console.log("BASELINEEEE props mgs", props, modelGroupSegments, isCustomValues);

  const renderCosts = (modelGroupSegments) => {
    const costsColumn = (model) => {
      const runId = model && model.runId;
      const setup = model && model.setup ? model.setup : setup ? setup : {};

      console.log("WTF IS THIS mgs, model, setup", modelGroupSegments, model.setup, setup);

      return (
        <div className={styles.costsColumn}>
          <div
            className={styles.costsColumnHeader}
            style={{
              backgroundColor: model.color,
              color: model.label === "Overall" ? "#FFFF" : "black"
            }}
          >
            {model.label}
          </div>
          {isCustomValues ? (
            Object.keys(setup.customValues).map((v) => (
              <div className={styles.costsInputSection} key={v}>
                <LineInput
                  isMediumBox
                  labelStyle={{ color: "#4B495B" }}
                  value={
                    setup && setup.baselineCustomValues && setup.baselineCustomValues[v] !== undefined
                      ? setup.baselineCustomValues[v]
                      : setup.customValues[v]
                  }
                  onChange={(val) => updateBaselineCustomValue(runId, setup.blueprintId, v, val)}
                />
              </div>
            ))
          ) : (
            <React.Fragment>
              <div className={styles.costsInputSection}>
                <LineInput
                  isMediumBox
                  labelStyle={{ color: "#4B495B" }}
                  value={
                    setup.baselineConversionGain !== undefined ? setup.baselineConversionGain : setup.conversionGain
                  }
                  onChange={(val) => updateBaselineConversionGain(runId, val)}
                />
              </div>
              <div className={styles.costsInputSection}>
                <LineInput
                  isMediumBox
                  labelStyle={{ color: "#4B495B" }}
                  value={
                    setup.baselineConversionCost !== undefined ? setup.baselineConversionCost : setup.conversionCost
                  }
                  onChange={(val) => updateBaselineConversionCost(runId, val)}
                />
              </div>
              <div className={styles.costsInputSection}>
                <LineInput
                  isMediumBox
                  labelStyle={{ color: "#4B495B" }}
                  value={
                    setup.baselineConversionSaved !== undefined ? setup.baselineConversionSaved : setup.conversionSaved
                  }
                  onChange={(val) => updateBaselineConversionSaved(runId, val)}
                />
              </div>
              <div className={styles.costsInputSection}>
                <LineInput
                  isMediumBox
                  labelStyle={{ color: "#4B495B" }}
                  value={
                    setup.baselineConversionMissed !== undefined
                      ? setup.baselineConversionMissed
                      : setup.conversionMissed
                  }
                  onChange={(val) => updateBaselineConversionMissed(runId, val)}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      );
    };

    const renderCostsColumns = () => {
      if (modelGroupSegments && modelGroupSegments.length > 0) {
        const models = modelGroupSegments.map((model) => {
          return <React.Fragment key={model.runId}>{costsColumn(model)}</React.Fragment>;
        });
        return models;
      } else if (modelGroupSegments.runId) {
        return costsColumn(modelGroupSegments);
      }
      return null;
    };

    return (
      <div className={styles.baselineCostsSection}>
        <div className={styles.costsLabelColumn}>
          <div style={{ minHeight: "30px" }}></div>
          {isCustomValues ? (
            Object.keys(setup.customValues).map((v) => (
              <div
                key={v}
                style={{
                  height: "45px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                {v}
              </div>
            ))
          ) : (
            <React.Fragment>
              <div className={styles.costsLabelRow}>{setup.truePositiveLabel}</div>
              <div className={styles.costsLabelRow}>{setup.falsePositiveLabel}</div>
              <div className={styles.costsLabelRow}>{setup.trueNegativeLabel}</div>
              <div className={styles.costsLabelRow}>{setup.falseNegativeLabel}</div>
            </React.Fragment>
          )}
        </div>
        {renderCostsColumns()}
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "#FFF",
        margin: "0px 10px",
        display: "flex",
        flexDirection: "column",
        padding: "20px 20px",
        width: "calc(100%)"
      }}
    >
      {isBaseline || modelGroups === undefined ? (
        <React.Fragment>
          <div style={{ fontWeight: "bold", fontSize: "18px" }}>My Business Drivers</div>
          {modelGroupSegments && renderCosts(modelGroupSegments)}
          {modelGroups !== undefined && (
            <div style={{ marginTop: "10px", width: "300px" }}>
              <Button
                type="secondary"
                onClick={() => {
                  /*if (isBaseline) {
                  if (isCustomValues) {
                    const idsList = modelGroupSegments.map(
                      (segment) => segment.runId
                    );
                    removeBaselineCustomValuesMultipleSegments(
                      idsList,
                      setup.blueprintId,
                      runId
                    );
                  }

                  setup.baselineConversionGain !== undefined &&
                    updateBaselineConversionGain(runId, undefined);
                  setup.baselineConversionCost !== undefined &&
                    updateBaselineConversionCost(runId, undefined);
                  setup.baselineConversionSaved !== undefined &&
                    updateBaselineConversionSaved(runId, undefined);
                  setup.baselineConversionMissed !== undefined &&
                    updateBaselineConversionMissed(runId, undefined);
                }*/
                  updateShowBaselines(false);
                }}
              >
                Remove Baseline Costs
              </Button>
            </div>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "20px",
              marginBottom: "10px"
            }}
          >
            Would you like to see the AI Impact on profit?
          </div>
          <div>This will also convert the AI Impact from % to $</div>
          <div style={{ marginTop: " 20px", width: "300px" }}>
            <Button onClick={() => updateShowBaselines(true)} type="secondary">
              Add Baseline Business Costs
            </Button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default BaselineCostsCard;
